import { render, staticRenderFns } from "./questionFiles.vue?vue&type=template&id=4844096c&scoped=true"
import script from "./questionFiles.vue?vue&type=script&lang=js"
export * from "./questionFiles.vue?vue&type=script&lang=js"
import style0 from "./questionFiles.vue?vue&type=style&index=0&id=4844096c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844096c",
  null
  
)

export default component.exports